<template>
  <ul class="navbar-nav dropdown">
    <li
      class="nav-item btn border-top-0 border-gradient-glow-warning-bottom rounded-0 rounded-top dropdown-toggle d-flex align-items-center text-center text-md-start py-1 px-3 fs-5"
      type="button"
      id="language-switche-dropdown"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      style="height: 56px"
    >
      <i class="bi bi-globe-americas text-warning"></i>
      <span class="mx-3 text-capitalize">{{ locale }}</span>
    </li>

    <ul class="dropdown-menu" aria-labelledby="languageSwitcher">
      <li
        v-for="sLocale in supportedLocales"
        :key="sLocale"
        @click="switchLanguage(sLocale)"
        style="cursor: pointer"
      >
        <a class="dropdown-item">
          {{ getLangTranslit(sLocale) }}
        </a>
      </li>
    </ul>
  </ul>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Tr from "@/i18n/translition";
import localesList from "@/i18n/supportedLocales.json";
import { configurations } from "@/store/modules/hotel/configuration";

@Options({})
class LanguageSwitcher extends Vue {
  get supportedLocales(): string[] {
    const locales: string[] = configurations().getLags;
    return locales.length ? locales : Tr.supportedLocales;
  }

  get locale(): string {
    return Tr.locale;
  }

  getLangTranslit(lang: string): string {
    const locales: { [x: string]: string } = localesList;
    return Object.keys(locales).includes(lang) ? locales[lang] : lang;
  }

  switchLanguage = async (newLocale: string) => {
    await Tr.switchLanguage(newLocale);
  };
}
export default LanguageSwitcher;
</script>
<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";
:root {
  --oc-border-010: #{rgba($warning, 0.1)};
}

[data-bs-theme="dark"] {
  --oc-border-010: #{rgba($warning, 0.1)};
}

[data-bs-theme="dark"] .dropdown-item:hover,
[data-bs-theme="dark"] .dropdown-item:focus {
  background-color: var(--oc-border-010) !important;
}

.nav-item {
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
}

.nav-item:hover,
.nav-item:focus {
  background-color: var(--oc-border-010);
}
</style>
